import {View, TouchableOpacity, ScrollView} from 'react-native';
import React from 'react';
import {IStateProps} from './model';
import {QrCode} from '../../shared/components/qrCode';
import {Barcode} from '../../shared/components/barcode';
import {GradientView} from '../../shared/components/gradientView';
import {useTheme} from '../../shared/theme';
import Modal from 'react-native-modal';
import {useAlign} from '../../shared/theme/helpers';
import {Text} from '../../shared/components/text';
import {CardNumber} from '../../shared/components/cardNumber';
import {images} from '../../assets/icons';
import {useAppState} from '../../shared/hooks/useAppState';
import {GetStyles} from './style';

const contentHeight = 620;

export default ({code, isCampusParticipant, onClose}: IStateProps) => {
  const theme = useTheme();
  const align = useAlign();
  const scrollViewRef = React.useRef<ScrollView>(null);
  const [scrollOffset, setScrollOffset] = React.useState<number | undefined>(undefined);
  const [visible, setVisible] = React.useState(true);
  const appState = useAppState();

  const styles = GetStyles(align, theme);

  React.useEffect(() => {
    if (appState === 'background') {
      onClose();
    }
  }, [appState]);

  const handleScrollTo = React.useCallback((p: any) => {
    if (scrollViewRef.current) {
      scrollViewRef.current.scrollTo(p);
    }
  }, []);

  const handleOnScroll = (event: any) => setScrollOffset(event.nativeEvent.contentOffset.y);

  return (
    <Modal
      isVisible={visible}
      onModalHide={onClose}
      onSwipeComplete={() => setVisible(false)}
      swipeDirection='down'
      scrollTo={handleScrollTo}
      scrollOffset={scrollOffset}
      scrollOffsetMax={contentHeight}
      propagateSwipe={true}
      style={styles.modal}
      backdropTransitionOutTiming={0}>
      <GradientView style={styles.container} gradient={{angle: 90, colors: theme.qrCodeScreen.bgGradient}}>
        <TouchableOpacity testID={`card-code-${code}-id`} onPressOut={() => setVisible(false)}>
          <images.ArrowDownWide height={11} width={28} color={theme.color.labelText} style={styles.closeButton} />
        </TouchableOpacity>
        <ScrollView ref={scrollViewRef} onScroll={handleOnScroll} scrollEventThrottle={16}>
          <View testID='qr-code-container-id' style={styles.innerContainer}>
            {isCampusParticipant && (
              <View style={styles.campusMembershipWrapper}>
                <images.CampusCard width={align(290)} height={align(108)} />
              </View>
            )}
            <View style={styles.barcodeWrapper}>
              <QrCode text={code} size={align(290)} />
              {code && <Barcode height={60} value={code} style={styles.barcode} />}
            </View>
            <View style={styles.cardNumberContainer}>
              <Text testID='card-number-qr-id' style={styles.cardNumberTitle}>
                Номер карты
              </Text>
              <CardNumber textStyle={styles.cardNumberText} />
            </View>
          </View>
        </ScrollView>
      </GradientView>
    </Modal>
  );
};
